import React from 'react'
import classnames from 'classnames'
import { AnimatePresence, motion } from 'framer-motion'
import PropTypes from 'prop-types'
import { ANIMATION } from 'helpers/constants'

const modalVariants = {
  hidden: { y: '100%', opacity: 0 },
  visible: {
    y: '0%',
    opacity: 1,
  },
}
const modalTransaction = {
  y: ANIMATION.SOFT_SPRINT,
}

const contentVariants = {
  enter: {
    x: '100%',
    opacity: 0,
  },
  visible: {
    x: '0%',
    opacity: 1,
    zIndex: 1,
  },
  hidden: {
    x: '-100%',
    opacity: 0,
    zIndex: 0,
  },
}

const contentTransaction = {
  x: ANIMATION.SOFT_SPRINT,
}

const OUTER_STYLE =
  'flex flex-col rounded-t-3xl w-full h-11/12 sm:rounded-3xl sm:w-max sm:mx-auto sm:h-auto sm:bg-transparent'
const INNER_STYLE = 'flex-1 sm:rounded-lg'

const Modal = ({ onAnimationComplete, children, outerClassName, innerClassName }) => (
  <motion.article
    variants={modalVariants}
    transition={modalTransaction}
    className={classnames(OUTER_STYLE, outerClassName)}
    onAnimationComplete={onAnimationComplete}
  >
    <AnimatePresence exitBeforeEnter initial={false}>
      <motion.div
        variants={contentVariants}
        initial="enter"
        animate="visible"
        exit="hidden"
        className={classnames(INNER_STYLE, innerClassName)}
        transition={contentTransaction}
        onAnimationComplete={onAnimationComplete}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  </motion.article>
)

Modal.propTypes = {
  onAnimationComplete: PropTypes.func,
}

export default Modal
